var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteLinksIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 17.999,
    viewBox: "0 0 17.999 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SiteLinksIcon",
    d: "M9,15l6-6M11,6l.463-.536a5,5,0,1,1,7.071,7.072L18,13m-5,5-.4.534a5.068,5.068,0,0,1-7.127,0,4.972,4.972,0,0,1,0-7.071L6,11",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLinksIconDark);
export default __webpack_public_path__ + "static/media/SiteLinksIconDark.a3a87f9b671108dd634c29f6402eae31.svg";
export { ForwardRef as ReactComponent };